import { Injectable } from '@angular/core';
import ProfileSdk from "@shdr/profile-sdk";

@Injectable({ providedIn: 'root' })
export class ProfileSdkService {

  private readonly profileSdk = new ProfileSdk();

  getInstance(): ProfileSdk {
    return this.profileSdk;
  }
}